import React, { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';
import moment from 'moment';
import { message } from 'antd';
import { MSG } from 'commons/constants';


const useIndicatorsAsk = () => {
  /* ======================================================
   * state
   * ====================================================== */
  const [indicatorList, setIndicatorList] = useState<any[]>();
  const [indicatorValue, setIndicatorValue] = useState<indicatorValueResDto>();

  /* ======================================================
   * hooks
   * ====================================================== */
  const location = useLocation();

  const searchParams = qs.parse(location.search);
  
  const { isLoading, refetch } = useQuery(
    [endpoints.management.indicators.ask, [location.search]],
    () =>
      fetcher.management.postIndicatorAsk({
        lecture_type: searchParams.lecture_type ? searchParams.lecture_type != 'A' ? String(searchParams.lecture_type) : "" : "",           
        searchDateEnd: searchParams.searchDateEnd ? String(searchParams.searchDateEnd) : moment().format('YYYY'), 
      }),
    {
      onSuccess: (res: indicatorListResDto) => {
        switch (res.code) {
          case 200:
            setIndicatorList(res.result?.list);
            setIndicatorValue(res.result?.value);
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  const { mutate: uppdate } = useMutation(
    [endpoints.management.indicators.val.updateType],
    fetcher.management.postIndicatorTypeUpdateValue,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            refetch();
            message.info(MSG.SUCCESS_SAVE, 1);
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )   

  return { indicatorList, indicatorValue, refetch, uppdate };
};

export default useIndicatorsAsk;
